import Modal from "./top/modal.es6";
import ScrollFunc from "./top/scrollfunc.es6";
import Kv from './top/kv.es6'

class Main {
    constructor() {
        this.modal = new Modal();
        this.scrollFunc = new ScrollFunc();
        this.kv = new Kv()
    }
}

const main = new Main();
